import * as Sentry from "@sentry/react";
import { version } from "../package.json"
import { useAuthAccountStore, useAuthCompanyStore, useCompaniesStore, useLocalStore, useLoggedUserStore, useProductStore, } from "@sicarx/sxw-api"

Sentry

const initSentry = () => {

    Sentry.init({
        release: version,
        environment: import.meta.env.VITE_ENVIRONMENT,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
            Sentry.httpContextIntegration(),
        ],
        sendDefaultPii: false,
        defaultIntegrations: false,
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        async beforeSend(event) {
            setInfo(Sentry)
            return event
        },

    })

}

const setInfo = (setter: typeof Sentry | Sentry.Scope) => {

    try {
        const account = useAuthAccountStore?.getState?.()?.authAccount
        if (!account?.logged) return false

        const company = useAuthCompanyStore.getState().authCompany
        const branch = useCompaniesStore.getState().companies.branchOffice
        const warehouseId = useLocalStore.getState().getLocal()?.warehouse?.uuid
        const priceListId = useProductStore.getState().prices.priceList?.uuid
        const loggedUser = useLoggedUserStore.getState().loggedUser

        const info = {
            user: {
                id: loggedUser?.uuid,
                email: account.email,
                username: `${account.firstName} ${account.lastName}`,
            },
            tags: {
                'content.id': company?.contentId,
                'branch.id': branch?.id,
                'company.alias': company?.alias,
                'branch.alias': branch?.alias,
                'platform': window?.electron ? 'ELECTRON' : 'WEB'
            },
            extra: {
                'Country': branch.countryName,
                'Admin': company.isAdmin,
                'User type': loggedUser?.userTypeName,
                'PriceList ID': priceListId,
                'Warehouse ID': warehouseId
            }
        }

        setter.setUser(info.user)
        setter.setTags(info.tags)
        setter.setExtras(info.extra)

        // setter.setContext('')


        return true
    } catch (err) {
        console.log('ErrorSetInfo', err)
        return false
    }
}


export default initSentry
